module.exports = __webpack_public_path__ + "media/images/photo/Agriculture/slider2-f35bb5f51b3e5a0a0aba80ea712a0233.png";